
module.exports = (v) => {
  let dotsCount = 0;
  return v
      .replace(/[,.]/gim, () => dotsCount++ < 1 ? '.' : '')
      .replace(/[^0-9.]/gim, '')
      .replace(/([.][0-9]{2})([0-9]+)$/gim, '$1');
};
